window.addEventListener('pplrAppInitiated', function(e) {
    //console.log("Zepto Product Personalizer Loaded................");
    var characterLimit = $('.pplr-_zepto_hidden_freecharlimit').children("input.pplr_text").attr("maxlength");
    $(".pplr-_zepto_hidden_freecharlimit").hide();
    $(".pplr-_zepto_hidden_priceperletter").hide();
    var targetTextArea = $('.pplr-_zepto_hidden_priceperletter .pplraddprice');

    $(".pplr-enter-your-custom-text").each(function() {
        var textarea = $(this).find(".pplr_text");

        textarea.on("input keyup keydown", function() {
            var text = $(this).val();
            var textWithoutPunctuation = text.replace(/[^\w]|_/g, "");
            textWithoutPunctuation = textWithoutPunctuation.replace(/\\n/g, "");
            textWithoutPunctuation = textWithoutPunctuation.replace(/\\s/g, "");
            var textCount = textWithoutPunctuation.length;
            var textCount = text.length;
            const cutPoint = characterLimit;
            //console.log("Current Text Count: " + textCount);
            if(textCount > cutPoint) {
                //console.log("Inputting..........");
                //console.log(textCount);
                targetTextArea.val(textWithoutPunctuation.slice(cutPoint));
            }
            else {
                targetTextArea.val('');
            }
        });
    });
});